import { render } from "./SpinnerIcon.vue?vue&type=template&id=97823d22"
import script from "./SpinnerIcon.vue?vue&type=script&lang=js"
export * from "./SpinnerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__